/**
 * @description 这里是针对本应用的通用函数
 */
import nui from './nui';
import CONFIG from './config';

export default {
    // 获取状态值和图标
    getStatus (status) {
        status = parseInt(status);


        switch (status) {
            case 1: return { title: '未开始', icon: 'n-icon-pending c-status-' + status }
            case 2: return { title: '进行中', icon: 'n-icon-navigation c-status-' + status }
            case 3: return { title: '已完成', icon: 'n-icon-complete c-status-' + status }
            case 4: return { title: '暂停中', icon: 'n-icon-navigation c-status-' + status }
            case 0: return { title: '已逾期', icon: 'n-icon-outdate c-status-' + status }
        }
    },
    // 获取紧急度和图标
    getLevel (level) {
        switch (level) {
            case 'urgency': return { title: '紧急' }
            case 'high': return { title: '高' }
            case 'medium': return { title: '中' }
            case 'low': return { title: '低' }
            default: return {
                title: "-"
            }
        }
    },
    getNeedStatus () {
        return [
            { label: '需求确认', value: '1' },
            { label: '需求分析', value: '2' },
            { label: '技术评审', value: '3' },
            { label: '排期中', value: '4' },
            { label: '开发中', value: '5' },
            { label: '测试中', value: '6' },
            { label: '已上线', value: '7' },
            { label: '已关闭', value: '8' },
            { label: '已取消', value: '9' }
        ]
    },
    getCategory () {
        return [
            { label: '流程', value: '1' },
            { label: '主数据', value: '2' },
            { label: '开发', value: '3' },
            { label: '网络', value: '4' },
            { label: '报表', value: '5' },
            { label: '权限', value: '6' },
            { label: '培训', value: '7' },
        ]
    },
    getTeam () {
        return [
            { label: 'OA', value: '1' },
            { label: 'SAP', value: '2' },
            { label: 'PLM', value: '3' },
            { label: '微服务', value: '4' }
        ]
    },
    getProvince () {
        return [
            { "code": "110000", "value": "110000", "label": "北京" },
            { "code": "120000", "value": "120000", "label": "天津" },
            { "code": "130000", "value": "130000", "label": "河北省" },
            { "code": "140000", "value": "140000", "label": "山西省" },
            { "code": "150000", "value": "150000", "label": "内蒙古自治区" },
            { "code": "210000", "value": "210000", "label": "辽宁省" },
            { "code": "220000", "value": "220000", "label": "吉林省" },
            { "code": "230000", "value": "230000", "label": "黑龙江省" },
            { "code": "310000", "value": "310000", "label": "上海" },
            { "code": "320000", "value": "320000", "label": "江苏省" },
            { "code": "330000", "value": "330000", "label": "浙江省" },
            { "code": "340000", "value": "340000", "label": "安徽省" },
            { "code": "350000", "value": "350000", "label": "福建省" },
            { "code": "360000", "value": "360000", "label": "江西省" },
            { "code": "370000", "value": "370000", "label": "山东省" },
            { "code": "410000", "value": "410000", "label": "河南省" },
            { "code": "420000", "value": "420000", "label": "湖北省" },
            { "code": "430000", "value": "430000", "label": "湖南省" },
            { "code": "440000", "value": "440000", "label": "广东省" },
            { "code": "450000", "value": "450000", "label": "广西壮族自治区" },
            { "code": "460000", "value": "460000", "label": "海南省" },
            { "code": "500000", "value": "500000", "label": "重庆" },
            { "code": "510000", "value": "510000", "label": "四川省" },
            { "code": "520000", "value": "520000", "label": "贵州省" },
            { "code": "530000", "value": "530000", "label": "云南省" },
            { "code": "540000", "value": "540000", "label": "西藏自治区" },
            { "code": "610000", "value": "610000", "label": "陕西省" },
            { "code": "620000", "value": "620000", "label": "甘肃省" },
            { "code": "630000", "value": "630000", "label": "青海省" },
            { "code": "640000", "value": "640000", "label": "宁夏回族自治区" },
            { "code": "650000", "value": "650000", "label": "新疆维吾尔自治区" },
            { "code": "710000", "value": "710000", "label": "台湾省" },
            { "code": "810000", "value": "810000", "label": "香港特别行政区" },
            { "code": "820000", "value": "820000", "label": "澳门特别行政区" }
        ]
    },
    // 转换日期
    parseUTC (str) {
        if (!str) {
            return ''
        }

        var date = nui.parseDate(new Date(str))

        return `${date.year}-${date.month}-${date.day}`
    },
    parseUTCDateTime (str) {
        return str ? str.substring(0, str.lastIndexOf('.')).replace('T', ' ') : null
    },
    parseUTCDateTimeForString (str) {
        var dateStr = nui.parseDate(new Date(str));

        return `${dateStr.year}-${dateStr.month}-${dateStr.day} ${dateStr.hour}:${dateStr.minute}`
    },
    // 解析扩展字段
    parseField (that, data, loadAll) {
        return data.map(item => {
            switch (item.fieldName) {
                case '所属公司':
                    nui.request(that.API.company, { params: { parentId: 1 } }).then(res => {
                        that.extField.filter(item => item.label == '所属公司')[0].loading = false;
                        that.extField.filter(item => item.label == '所属公司')[0].options = res.data.map(item => {
                            return {
                                value: item.deptId,
                                label: item.deptName
                            }
                        })
                    })

                    if (loadAll) {
                        this.$nextTick(() => {
                            if (that.extField.filter(item => item.label == '部门')[0]) {
                                that.extField.filter(item => item.label == '部门')[0].disabled = false;
                                that.extField.filter(item => item.label == '部门')[0].loading = true;

                                nui.request(that.API.company, { params: { parentId: that.addForm['ext' + item.fieldId] } }).then(res => {
                                    that.extField.filter(item => item.label == '部门')[0].loading = false;

                                    if (res.data) {
                                        that.extField.filter(item => item.label == '部门')[0].options = res.data.map(item => {
                                            return {
                                                value: item.deptId,
                                                label: item.deptName
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }

                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'select',
                        url: that.API.company,
                        placeholder: "请选择所属公司",
                        options: [],
                        loading: true,
                        disabled: false,
                        onChange: () => {
                            that.extField.filter(item => item.label == '部门')[0].disabled = false;
                            that.extField.filter(item => item.label == '部门')[0].loading = true;
                            that.addForm['ext' + (that.extField.filter(item => item.label == '部门')[0].id)] = null;

                            nui.request(that.API.company, { params: { parentId: that.addForm['ext' + item.fieldId] } }).then(res => {
                                that.extField.filter(item => item.label == '部门')[0].loading = false;
                                that.extField.filter(item => item.label == '部门')[0].options = res.data.map(item => {
                                    return {
                                        value: item.deptId,
                                        label: item.deptName
                                    }
                                })
                            })

                        }
                    }
                case '部门':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'select',
                        placeholder: "请选择部门",
                        options: [],
                        loading: false,
                        disabled: true
                    }


                case '省份':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'select',
                        placeholder: "请选择省份",
                        options: this.getProvince(),
                        disabled: false
                    }


                case 'ITBP':
                    console.log(item.fieldValue ? [{ value: item.fieldValue.split(that.SPLIT)[0], label: item.fieldValue.split(that.SPLIT)[1] }] : []);
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'filterSelect',
                        url: that.API.getUserListByAddition,
                        placeholder: "请选择ITBP",
                        options: [],
                        loading: false,
                        params: {},
                        keywordKey: 'username',
                        valueKey: 'adName',
                        labelKey: 'userName',
                        disabled: false,
                        optionTitle: ['userName', 'position'],
                        onChange () {
                        }
                    }

                case '需求状态':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'select',
                        placeholder: "请选择需求状态",
                        options: this.getNeedStatus(),
                        disabled: false
                    }

                case '分类':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'select',
                        placeholder: "请选择分类",
                        options: this.getCategory(),
                        disabled: false
                    }

                case '团队':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'select',
                        placeholder: "请选择团队",
                        options: this.getTeam(),
                        disabled: false
                    }

                case '需求确认日期':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'date',
                        placeholder: "请选择日期",
                        disabled: false
                    }

                case '开发预计开始日期':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'date',
                        placeholder: "请选择日期",
                        disabled: false
                    }

                case '开发预计完成日期':
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'date',
                        placeholder: "请选择日期",
                        disabled: false
                    }

                default:
                    return {
                        id: item.fieldId,
                        label: item.fieldName,
                        type: 'input',
                        placeholder: "请输入" + item.fieldName,
                        disabled: false
                    }
            }
        })
    },
    formatTaskData (data, mathSub = true, extField) {
        var extFields = extField ? extField.filter(item => item.ext) : [];

        return data.map(item => {
            var cache = {
                key: item.taskId,
                pId: item.pId,
                id: item.taskId,
                title: item.taskName,
                level: item.priority ? parseOldLevel(item.priority) : '未设置',
                status: item.status,
                creator: item.creator,
                charge: item.principalList ? item.principalList.join('，') : '',
                executor: item.executorList ? item.executorList.join('，') : '',
                start: this.parseUTC(item.startTime),
                end: this.parseUTC(item.endTime),
                children: mathSub && item.subCount ? [] : undefined,
                statusLoading: false
            }

            extFields.forEach(sItem => {
                var value = item.taskFieldList.filter(fItem => ('ext' + fItem.fieldId) == sItem.key)[0];

                if (value && value.fieldValue) {
                    cache[sItem.key] = value.fieldValue.indexOf(CONFIG.SPLIT) >= 0 ? value.fieldValue.split(CONFIG.SPLIT)[1] : value.fieldValue
                } else {
                    cache[sItem.key] = '-'
                }
            })

            return cache
        })

        function parseOldLevel (level) {
            if (level.indexOf(CONFIG.SPLIT) >= 0) {
                return level
            } else {
                switch (level) {
                    case '紧急': return 'urgency'
                    case '高': return 'high'
                    case '中': return 'medium'
                    case '低': return 'low'
                    default: return level
                }
            }
        }
    },
    parseFilterTags (data, type) {
        var cache = nui.extend({}, data);

        for (let index in cache) {
            let item = cache[index];

            switch (index) {
                case 'title':
                    cache[index] = {
                        title: item ? '标题：' + item : false,
                        key: index
                    }
                    break

                case 'start':
                    cache[index] = {
                        title: item ? '开始日期：' + item : false,
                        key: index
                    }
                    break

                case 'end':
                    cache[index] = {
                        title: item ? '截止日期：' + item : false,
                        key: index
                    }
                    break

                case 'tag':
                    var tags = cache[index].map(tagItem => {
                        tagItem = cache.tags.filter(item => item.id == tagItem)[0].name
                        return tagItem
                    })

                    cache[index] = {
                        title: cache[index].length > 0 ? '标签：' + tags.join('，') : false,
                        key: index
                    }
                    break

                case 'charge':
                    var charges = cache[index].map(chargeItem => {
                        chargeItem = cache.charges.filter(item => item.adName == chargeItem)[0].userName
                        return chargeItem
                    })

                    cache[index] = {
                        title: cache[index].length > 0 ? '负责人：' + charges.join('，') : false,
                        key: index
                    }
                    break

                case 'executor':
                    var executors = cache[index].map(executorItem => {
                        executorItem = cache.executors.filter(item => item.adName == executorItem)[0].userName
                        return executorItem
                    })

                    cache[index] = {
                        title: cache[index].length > 0 ? '执行人：' + executors.join('，') : false,
                        key: index
                    }
                    break

                case 'onlyLeader':
                    var leader = cache[index].map(leaderItem => {
                        leaderItem = cache.onlyLeaders.filter(item => item.adName == leaderItem)[0].userName
                        return leaderItem
                    })

                    cache[index] = {
                        title: cache[index].length > 0 && type == 'panel' ? '仅查看' + leader.join('，') + '的项目' : false,
                        key: index
                    }
                    break

                default:
                    cache[index] = cache[index]
            }
        }

        delete cache.charges
        delete cache.executors
        delete cache.tags
        delete cache.onlyLeaders

        for (let index in cache) {
            if (cache[index].title == false) {
                delete cache[index]
            }
        }

        return cache
    },
    editorNull (data) {
        console.log(data);
        if (data && data.length == 0) {
            return true
        } else if (data && data.ops && data.ops.length == 0) {
            return true
        } else if (data && data.ops && data.ops.length > 0) {
            var arr = data.ops.map(item => {
                if (item.insert) {
                    if ((typeof item.insert).toLowerCase() == 'string') {
                        return item.insert.replace(/[\r\n]/g, '').replace(/\s+/g, '')
                    } else {
                        return item.insert
                    }
                } else {
                    return ''
                }
            })
            return arr.join('') == ''
        }

        return false
    }
}